<template>
  <div v-if="is_loading == false">
    <modal
      name="modal_croppie"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <div id="modal_croppie" class="col">
        <div class="row" v-if="form_file != null">
          <div class="col">
            <div class="row">
              <div id="croppieCol" class="col">
                <vue-croppie
                  id="croppieRef"
                  ref="croppieRef"
                  :enableResize="false"
                  :viewport="{ width: 200, height: 200, type: 'circle' }"
                  v-on:result="fn"
                ></vue-croppie>
              </div>
            </div>
            <div class="row">
              <div class="col aling-center">
                <button
                  id="sign-in"
                  type="button"
                  class="btn btn-dark"
                  v-on:click="crop"
                >
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col aling-center">
            <div class="form-group">
              <label for="form_file">Adicione a sua foto clicando abaixo</label>
              <input
                type="file"
                class="form-control-file"
                id="form_file"
                ref="form_file"
                v-on:change="previewFiles"
              />
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div id="profile" class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <div id="imgProfile" v-on:click="setImage"></div>
          </div>
        </div>
        <div class="row justify-content-md-center sized-top-20">
          <div class="col-md-auto">
            <div class="form-group">
              <label for="form_phone">Seu nome:</label>
              <input
                v-model="form_name"
                type="text"
                class="form-control"
                id="form_name"
                aria-describedby="nameHelp"
                placeholder="digite aqui"
              />
              <small
                id="nameHelp"
                v-bind:class="
                  (form_name == ''
                    ? 'text-muted'
                    : validateName(form_name)
                    ? 'text-success'
                    : 'text-danger') + ' form-text'
                "
                >*
                {{
                  form_name == ''
                    ? 'Nome válido'
                    : validateName(form_name)
                    ? 'Nome válido'
                    : 'Nome inválido'
                }}</small
              >
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-md-auto">
            <button
              id="sign-in"
              type="button"
              class="btn btn-dark"
              v-bind:disabled="form_name_valid.length <= 3"
              v-on:click="updateProfile"
            >
              Salvar minhas informações
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loader"></div>
  </div>
</template>

<script>
import { auth, storage } from '../configs/firebase.js';

export default {
  name: 'Profile',
  data() {
    return {
      is_loading: false,
      form_name: '',
      form_name_valid: '',
      form_photo: null,
      form_file: null,
      form_cropped: null
    };
  },
  computed: {
    user: function () {
      return this.$root.user;
    }
  },
  methods: {
    validateName(name) {
      if (name.length > 3) {
        this.form_name_valid = name;
        return true;
      }
      return false;
    },
    async updateProfile() {
      try {
        this.is_loading = true;

        let payload = {
          displayName: this.form_name_valid
        };

        if (this.form_cropped != null) {
          let ref = storage.ref('users/profile/' + this.user.uid);

          let uploadTask = await ref.putString(
            this.form_cropped.replace('data:image/jpeg;base64,', ''),
            'base64',
            { contentType: 'image/jpeg' }
          );

          let downloadURL = await uploadTask.ref.getDownloadURL();

          payload.photoURL = downloadURL;
        }

        await auth.currentUser.updateProfile(payload);

        alert('Perfil salvo com sucesso, solicite a sua entrega');
      } catch (e) {
        //console.log(e);

        alert('Erro ao salvar seu perfil, tente novamente');
      } finally {
        this.is_loading = false;
      }
    },
    setImage() {
      this.$modal.show('modal_croppie');
    },
    crop() {
      let options = {
        format: 'jpeg',
        circle: false,
        quality: 1,
        size: {
          width: 300,
          height: 300
        }
      };

      this.$refs.croppieRef.result(options);
    },
    fn(output) {
      this.form_cropped = output;

      this.$el.style.setProperty(
        '--photo-img',
        'url(' + this.form_cropped + ')'
      );

      this.$modal.hide('modal_croppie');
    },
    previewFiles() {
      try {
        this.form_file = this.$refs.form_file.files;
      } catch (e) {
        //console.log(e);
      }
    },
    initUserData() {
      try {
        if (this.user.displayName != null) {
          this.form_name = this.user.displayName;
        }

        if (this.user.photoURL != null) {
          this.form_photo = this.user.photoURL;
        } else {
          this.$el.style.setProperty(
            '--photo-img',
            'url(https://urbanodelivery.com.br/img_avatar.png)'
          );
        }
      } catch (e) {
        //console.log(e);
      }
    }
  },
  watch: {
    user() {
      this.initUserData();
    },
    form_photo() {
      this.$el.style.setProperty(
        '--photo-img',
        'url(' + this.user.photoURL + ')'
      );
    },
    form_file() {
      let reader = new FileReader();

      reader.onloadend = () => {
        this.$nextTick(() => {
          this.$refs.croppieRef.bind({
            url: reader.result
          });
        });
      };

      reader.readAsDataURL(this.form_file[0]);
    }
  },
  mounted() {
    this.initUserData();
  }
};
</script>

<style>
#profile {
  width: 912px;
  margin: 20px auto;
  text-align: center;
  padding: 10px;
}

#form_name {
  min-width: 300px;
}

#imgProfile {
  position: relative;
  left: calc(50% - 100px);
  border-radius: 50%;
  width: 200px;
  height: 200px;
  background-image: var(--photo-img);
  background-size: 100% 100%;
  cursor: pointer;
}

#croppieRef {
  width: 200px;
  height: 200px;
}

#croppieCol {
  left: calc(50% - 120px);
  min-height: 240px;
}

#modal_croppie {
  padding: 10px;
}

@media only screen and (max-width: 912px) {
  #profile {
    width: 100%;
    padding: 0px;
  }
  #form_name {
    min-width: 0px;
  }
}
</style>
